import React, { useContext, useEffect, useState } from "react";
import api from "../../services/api";
import AppContext from "../../container/context";
import Form from "../../components/form";
import { Button, CircularProgress, Fab, Stack, Tooltip } from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import ArrowUpwardIcon from "@mui/icons-material/ArrowUpward";
import ArrowDownwardIcon from "@mui/icons-material/ArrowDownward";
import DeleteIcon from "@mui/icons-material/Delete";

export default function PlanoAulas(props) {
  const [planoId] = useState(Number(props.match.params.id));
  const history = props.history;
  const { notification, confirm } = useContext(AppContext);
  const [carregando, setCarregando] = useState(false);
  const [planoAulas, setPlanoAulas] = useState({});
  const [listaAulas, setListaAulas] = useState([]);
  const [qtdAulas, setQtdAulas] = useState(0);
  const [aulaId, setAulaId] = useState("");
  const [listaFuncoes, setListaFuncoes] = useState([]);

  useEffect(() => {
    if (planoId > 0) {
      carregar();
      carregarListaAulas();
      carregarFuncoes();
    }
  }, []);

  const carregar = () => {
    setCarregando(true);

    api
      .get("planosAulas/carregar", { id: planoId })
      .then((res) => {
        setPlanoAulas(res);
        setCarregando(false);
      })
      .catch((err) => {
        notification("error", "Não foi possível carregar plano de aulas");
        setCarregando(false);
      });
  };

  const carregarListaAulas = () => {
    api
      .get("planosAulas/aulas/listar", { planoAulasId: planoId })
      .then((res) => {
        setListaAulas(res);
      });
  };
  const carregarFuncoes = () => {
    api.get("funcoes/listar").then((res) => {
      setListaFuncoes(res);
    });
  };

  const salvar = (params) => {
    if (planoId > 0) {
      params.id = planoId;
      api
        .post("planosAulas/editar", params)
        .then((res) => {
          notification("success", "Plano de aula editado!");
          carregar();
        })
        .catch((err) => {
          const { data } = err;
          switch (data[0]) {
            case 1:
              return notification("error", "Nome inválido");
            default:
              return notification("error", "Dados inválidos");
          }
        });
    } else {
      api
        .put("planosAulas/inserir", params)
        .then((res) => {
          notification("success", "Plano de aulas salvo!");
          history.goBack();
        })
        .catch((err) => {
          const { data } = err;
          switch (data[0]) {
            case 1:
              return notification("error", "Nome inválido");

            default:
              return notification("error", "Dados inválidos");
          }
        });
    }
  };

  const fPlano = {
    title: "Plano de aulas",
    form: {
      nome: {
        label: "Nome",
        type: "text",
        space: 8,
        value: planoAulas.nome ? planoAulas.nome : "",
      },
      inativacao: {
        label: "Exibir inativas",
        type: "date",
        space: 4,
        value: planoAulas.ativas ? planoAulas.ativas : "",
      },
    },

    submit: {
      label: "salvar",
      action: salvar,
    },
    history,

    close: {},
  };

  const inserirQtdAulas = (qtd) => {
    api
      .post("planosAulas/aulas/inserir", {
        planoAulasId: planoId,
        quantidade: qtd,
      })
      .then((res) => {
        notification("success", "Quatidade de aulas inserido!");
        setQtdAulas(0);
        carregarListaAulas();
      })
      .catch((err) => {
        return notification("error", "Erro ao inserir quantidade de aulas");
      });
  };

  const fQtdAulas = {
    title: "Plano de aulas",
    form: {
      qtdAulas: {
        label: "Quantidade de aulas",
        type: "number",
        space: 12,
        value: qtdAulas.length,
      },
    },
    submit: {
      label: "Incluir aulas",
      action: (e) => {
        e.qtdAulas <= 0
          ? notification("warning", "Número de aulas inválido")
          : inserirQtdAulas(e.qtdAulas);
      },
    },
  };

  const salvarAula = (aulaEnviar) => {
    aulaEnviar.planoAulasAulaId = aulaId;

    api
      .post("planosAulas/aulas/editar", aulaEnviar)
      .then((res) => {
        notification("success", "Dados de aula editado!");
        carregarListaAulas();
        setAulaId("");
      })
      .catch((err) => {
        const { data } = err;
        switch (data[0]) {
          case 1:
            return notification("error", "Função responsável inválida");
          default:
            return notification("error", "Dados inválidos");
        }
      });
  };

  const montarForm = (dados, index) => {
    if (dados.planoAulasAulaId === aulaId) {
      return {
        form: {
          titulo: {
            label: "Título",
            type: "text",
            space: 4,
            value: dados.planoAulasAulaTitulo
              ? dados.planoAulasAulaTitulo
              : `(sem título)`,
          },
          responsavelFuncaoId: {
            label: "Responsável",
            type: "select",
            emptyItem: true,
            space: 4,
            array: {
              data: listaFuncoes,
              value: "id",
              desc: "nome",
            },
            value: dados.planoAulasAulaResponsavelFuncaoId,
          },
          diasDuracao: {
            label: "Dias de duração",
            type: "number",
            space: 4,
            value: dados.planoAulasAulaDiasDuracao,
          },
          descricao: {
            label: "Descrição",
            type: "textarea",
            space: 12,
            value: dados.planoAulasAulaDescricao
              ? dados.planoAulasAulaDescricao
              : "(sem descrição)",
          },
        },
        submit: {
          label: "Salvar",
          action: salvarAula,
        },
        close: {
          label: "cancelar",
          action: () => setAulaId(""),
        },
      };
    } else {
      return {
        form: {
          planoAulasAulaTitulo: {
            label: "Título",
            type: "text",
            space: 4,
            readOnly: true,
            value: dados.planoAulasAulaTitulo
              ? dados.planoAulasAulaTitulo
              : `(sem título)`,
          },
          planoAulasAulaResponsavelFuncaoNome: {
            label: "Responsável",
            type: "text",
            space: 4,
            readOnly: true,
            value: dados.planoAulasAulaResponsavelFuncaoNome,
          },
          planoAulasAulaDiasDuracao: {
            label: "Dias de duração",
            type: "text",
            space: 4,
            readOnly: true,
            value: dados.planoAulasAulaDiasDuracao,
          },
          planoAulasAulaDescricao: {
            label: "Descrição",
            type: "textarea",
            space: 12,
            readOnly: true,
            value: dados.planoAulasAulaDescricao
              ? dados.planoAulasAulaDescricao
              : "(sem descrição)",
          },
        },
      };
    }
  };

  const removerAula = (item) => {
    const paramsEnviar = {
      planoAulasId: planoId,
      planoAulasAulaId: item.planoAulasAulaId,
    };

    confirm({
      title: "Deseja realmente remover a aula?",
      label: "Não será possível desfazer esta ação.",
      onConfirm: () => {
        api
          .delete("planosAulas/aulas/remover", paramsEnviar)
          .then((res) => {
            notification("success", "Aula removida!");
            carregarListaAulas();
          })
          .catch((err) => {
            return notification("error", "Erro ao remover");
          });
      },
    });
  };

  const moverAula = (pos, item) => {
    const paramEnviar = {
      planoAulasId: planoId,
      planoAulasAulaId: item.planoAulasAulaId,
      novaPosicao: pos,
    };

    api
      .post("planosAulas/aulas/mover", paramEnviar)
      .then((res) => {
        notification("success", "Ordem de aula alterada!");
        carregarListaAulas();
      })
      .catch((err) => {
        const { data } = err;
        switch (data[0]) {
          case 1:
            return notification(
              "error",
              "Posição inválida (deve ser entre 1 e a quantidade de aulas)"
            );
          default:
            return notification("error", "Dados inválidos");
        }
      });
  };

  return (
    <div>
      {carregando ? (
        <CircularProgress />
      ) : (
        <>
          <Form formData={fPlano} />
          {!listaAulas.length && planoId > 0 && <Form formData={fQtdAulas} />}

          {listaAulas.length > 0 && (
            <>
              {listaAulas.map((item, index) => (
                <div
                  key={index}
                  style={{ background: "white", padding: 15, marginTop: 15 }}
                >
                  <div style={{ display: "flex", alignItems: "center" }}>
                    <h4>Aula {index + 1} </h4>{" "}
                    {aulaId !== item.planoAulasAulaId && (
                      <Tooltip title="Editar">
                        <Fab
                          style={{ marginLeft: 10, color: "white" }}
                          size="small"
                          color="primary"
                          onClick={() => setAulaId(item.planoAulasAulaId)}
                        >
                          <EditIcon size="small" />
                        </Fab>
                      </Tooltip>
                    )}
                  </div>
                  <Form formData={montarForm(item, index)} />
                  <Stack spacing={2} direction="row" justifyContent={"end"}>
                    {listaAulas.length > 1 && (
                      <>
                        {index > 0 && (
                          <Button
                            style={{ color: "white" }}
                            variant="contained"
                            color="info"
                            onClick={() =>
                              moverAula(item.planoAulasAulaOrdem - 1, item)
                            }
                          >
                            <ArrowUpwardIcon />
                          </Button>
                        )}

                        {index + 1 !== listaAulas.length && (
                          <Button
                            style={{ color: "white" }}
                            variant="contained"
                            color="info"
                            onClick={() =>
                              moverAula(item.planoAulasAulaOrdem + 1, item)
                            }
                          >
                            <ArrowDownwardIcon />
                          </Button>
                        )}
                      </>
                    )}

                    <Button
                      style={{ color: "white" }}
                      variant="contained"
                      color="secondary"
                      onClick={() => removerAula(item)}
                    >
                      <DeleteIcon />
                    </Button>
                  </Stack>
                </div>
              ))}
              <div style={{ marginTop: 15, textAlign: "end" }}>
                <Button
                  style={{ color: "white" }}
                  variant="contained"
                  color="info"
                  onClick={() => inserirQtdAulas(1)}
                >
                  + Nova aula
                </Button>
              </div>
            </>
          )}
        </>
      )}
    </div>
  );
}
